export default __webpack_public_path__ + "static/media/nub-cigars.33bbf958.jpg";